import React from "react";
import PageHero from "../components/dental/PageHero";
import SectionTitle from "../components/dental/SectionTitle";
import Button from "../components/dental/Button";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock";
import { openWeaveBookingInNewTab, WEAVE_BOOKING_URL } from "../lib/weaveBooking";

const TestimonialsPage = () => (
  <>
    <PageHero
      subtitle="What Patients Say"
      title="Testimonials"
      breadcrumb="Testimonials"
      image="https://images.unsplash.com/photo-1639162906614-0603b0ae95fd"
    />

    <section className="bg-[#FBF8F1] py-20 md:py-24\">
      <div className="max-w-7xl mx-auto px-6">
        <SectionTitle script="Words Of" title="Praise" subtitle="Real Patient Stories" />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="relative bg-[#ffffff] p-8 border border-[#B79A68]/30 hover:border-[#B79A68] transition-colors"
            >
              <Quote
                size={48}
                className="absolute -top-3 left-5 text-[#7D6A42]/30"
                strokeWidth={1}
              />
              <div className="flex gap-0.5 mb-4 text-[#7D6A42]">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star key={i} size={14} fill="currentColor" stroke="none" />
                ))}
              </div>
              <p className="text-[#4E5750]/90 leading-relaxed italic">&ldquo;{t.text}&rdquo;</p>
              <div className="mt-6 pt-5 border-t border-[#B79A68]/20">
                <p className="font-cinzel gold-gradient-text uppercase tracking-[0.15em] text-sm">{t.name}</p>
                <p className="text-[#7D6A42] text-[10px] uppercase tracking-[0.3em] mt-1">{t.location}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-14">
          <p className="text-[#4E5750]/80 max-w-2xl mx-auto mb-6">
            Ready to write your own five-star review? Reserve your visit and experience the Galleria difference.
          </p>
          <Button href={WEAVE_BOOKING_URL} onClick={openWeaveBookingInNewTab}>Book a Consult</Button>
        </div>
      </div>
    </section>
  </>
);

export default TestimonialsPage;
